import { 
    START_GET_COURSETYPES,
} from '../types';

export const getCoursetypes = () => ({
    type: START_GET_COURSETYPES
})